import { AsyncPipe } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { UnenrolledDeviceStoreActions, UnenrolledDeviceStoreSelectors } from '@era/stores';
import { ListService, ListSimpleComponent } from '@ml-ag-grid-lib';
import { Store } from '@ngrx/store';
import { PanelComponent, PanelHeaderComponent, TitleComponent } from '@rocksoft/cdk';
import { Device } from '@rocksoft/shared';
import { ColDef, GridReadyEvent } from 'ag-grid-community';
import { Observable } from 'rxjs';
import { DepDevicesDeleteComponent } from '../dep-devices-delete/dep-devices-delete.component';

@Component({
  selector: 'ml-dep-devices',
  templateUrl: './dep-devices.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PanelComponent,
    PanelHeaderComponent,
    TitleComponent,
    DepDevicesDeleteComponent,
    ListSimpleComponent,
    AsyncPipe,
  ],
})
export class DepDevicesComponent {
  private readonly deviceStore = inject(Store);
  private readonly listService = inject(ListService);

  containsTextFilterParams = { filterOptions: ['contains'] };
  beforeAfterDateFilterParams = { filterOptions: ['lessThan', 'greaterThan'] };

  public columnDefs: ColDef[] = [
    {
      field: 'name',
      sortable: true,
      filterParams: this.containsTextFilterParams,
      checkboxSelection: true,
      headerCheckboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
    },
    { field: 'platform', sortable: true, filter: false },
    { field: 'udid', sortable: true, filter: false },
    { field: 'serialNumber', sortable: true, filterParams: this.containsTextFilterParams },
    { field: 'lastSeen', sortable: true, filterParams: this.beforeAfterDateFilterParams },
  ];

  public rowData$: Observable<Device[]>;

  public rowNodeIdProperty = 'udid';

  constructor() {
    this.rowData$ = this.deviceStore.select(UnenrolledDeviceStoreSelectors.selectAllDevices);
  }

  public onGridReady(gridReadyEvent: GridReadyEvent) {
    this.listService.addAgGridParams(gridReadyEvent);
  }

  public dispatchDelete() {
    const udids = this.listService.getSelectedNodeIds();
    this.deviceStore.dispatch(
      UnenrolledDeviceStoreActions.UnenrolledDeviceViewActions.unenrolledDevicesDeleteRequested({
        unenrolledDeviceIds: udids,
      })
    );
  }
}
